import { AnswerType } from "./lib/userdata";

export class InitializeEvent extends CustomEvent<undefined> {
	static type = 'mist.common.init';
	constructor() { super(InitializeEvent.type); }
}

export class TickEvent extends CustomEvent<undefined> {
	static type = 'mist.common.tick';
	constructor() { super(TickEvent.type); }
}

export class PingEvent extends CustomEvent<undefined> {
	static type = 'mist.common.ping';
	constructor() { super(PingEvent.type); }
}

export class NextEvent extends CustomEvent<undefined> {
	static type = 'mist.common.next';
	constructor() { super(NextEvent.type); }
}

export class PreviousEvent extends CustomEvent<undefined> {
	static type = 'mist.common.previous';
	constructor() { super(PreviousEvent.type); }
}

export class FinishEvent extends CustomEvent<undefined> {
	static type = 'mist.practicequestion.finish';
	constructor() { super(FinishEvent.type); }
}

export class JumpEvent extends CustomEvent<string> {
	static type = 'mist.common.jump';
	constructor(itemId: string) { super(JumpEvent.type, { detail: itemId}); }
}

export class FirstJumpEvent extends CustomEvent<string> {
	static type = 'mist.common.firstjump';
	constructor(itemId: string) { super(FirstJumpEvent.type, { detail: itemId}); }
}

export class NavigateEvent extends CustomEvent<string> {
	static type = 'mist.common.navigate';
	constructor(itemId: string) { super(NavigateEvent.type, { detail: itemId}); }
}

export class ReloadEvent extends CustomEvent<undefined> {
	static type = 'mist.common.reload';
	constructor() { super(ReloadEvent.type); }
}

export class PauseEvent extends CustomEvent<boolean> {
	static type = 'mist.common.pause';
	constructor(pause: boolean) { super(PauseEvent.type, { detail: pause }); }
}

export class AnswerEvent extends CustomEvent<AnswerType> {
	static type = 'mist.practicequestion.answer';
	constructor(answer: AnswerType) { super(AnswerEvent.type, { detail: answer }); }
}

export class FlipCardEvent extends CustomEvent<boolean> {
	static type = 'mist.flashcard.flip';
	constructor(front: boolean) { super(FlipCardEvent.type, { detail: front }); }
}

export class ToggleContextsEvent extends CustomEvent<string[]> {
	static type = 'mist.practicequestion.togglecontext';
	constructor(contexts: string[]) { super(ToggleContextsEvent.type, { detail: contexts }); }
}

export class ContextShownEvent extends CustomEvent<string> {
	static type = 'mist.practicequestion.contextshown';
	constructor(id: string) { super(ContextShownEvent.type, { detail: id }); }
}

export class ToggleTimerEvent extends CustomEvent<undefined> {
	static type = 'mist.practicequestion.toggletimer';
	constructor() { super(ToggleTimerEvent.type); }
}

export class KeyboardShortcutsEvent extends CustomEvent<boolean> {
	static type = 'mist.common.keyboardshortcuts';
	constructor(enabled: boolean) { super(KeyboardShortcutsEvent.type, { detail: enabled }); }
}

export class ChangeFontSizeEvent extends CustomEvent<number> {
	static type = 'mist.common.changefontsize';
	constructor(size: number) { super(ChangeFontSizeEvent.type, { detail: size }); }
}

export class SetFiltersEvent extends CustomEvent<string[]> {
	static type = 'mist.common.setfilters';
	constructor(filters: string[]) { super(SetFiltersEvent.type, { detail: filters }); }
}

export class ToggleFiltersEvent extends CustomEvent<string[]> {
	static type = 'mist.common.togglefilters';
	constructor(filters: string[]) { super(ToggleFiltersEvent.type, { detail: filters }); }
}

export class AddFiltersEvent extends CustomEvent<string[]> {
	static type = 'mist.common.addfilters';
	constructor(filters: string[]) { super(AddFiltersEvent.type, { detail: filters }); }
}

export class RemoveFiltersEvent extends CustomEvent<string[]> {
	static type = 'mist.common.removefilters';
	constructor(filters: string[]) { super(RemoveFiltersEvent.type, { detail: filters }); }
}

export class ClearFiltersEvent extends CustomEvent<undefined> {
	static type = 'mist.common.clearfilters';
	constructor() { super(ClearFiltersEvent.type); }
}

export class ToggleShortcutModalEvent extends CustomEvent<undefined> {
	static type = 'mist.common.toggleshortcutmodal';
	constructor() { super(ToggleShortcutModalEvent.type); }
}

export class StartEvent extends CustomEvent<HTMLElement> {
	static type = 'mist.practicequestion.start';
	constructor(element: HTMLElement) { super(StartEvent.type, { detail: element }); }
}

export class ShowReportModalEvent extends CustomEvent<undefined> {
	static type = 'mist.common.showreportmodal';
	constructor() { super(ShowReportModalEvent.type); }
}

export class ReportErrorEvent extends CustomEvent<HTMLFormElement> {
	static type = 'mist.common.reporterror';
	constructor(form: HTMLFormElement) { super(ReportErrorEvent.type, { detail: form }); }
}

export class EnterEmailEvent extends CustomEvent<HTMLInputElement> {
	static type = 'mist.common.enteremail';
	constructor(email: HTMLInputElement) { super(EnterEmailEvent.type, { detail: email }); }
}

export class InputOverrideEvent extends CustomEvent<{value: string, selector: string, root: HTMLElement}> {
	static type = 'mist.common.inputoverride';
	constructor(root: HTMLElement, selector: string, value: string) {
		super(InputOverrideEvent.type, { detail: { root, selector, value } });
	}
}

export class FlagEvent extends CustomEvent<boolean> {
	static type = 'mist.common.flag';
	constructor(flagged: boolean) { super(FlagEvent.type, { detail: flagged }); }
}

export class ToggleAdvanceEvent extends CustomEvent<boolean> {
	static type = 'mist.flashcard.toggleadvance';
	constructor(enable: boolean) { super(ToggleAdvanceEvent.type, { detail: enable }); }
}

export class ChangeAdvanceIntervalEvent extends CustomEvent<number> {
	static type = 'mist.flashcard.changeadvanceinterval';
	constructor(interval: number) { super(ChangeAdvanceIntervalEvent.type, { detail: interval }); }
}

export class AdvanceEvent extends CustomEvent<undefined> {
	static type = 'mist.flashcard.advance';
	constructor() { super(AdvanceEvent.type); }
}

export class ResetTimerEvent extends CustomEvent<undefined> {
	static type = 'mist.flashcard.reset';
	constructor() { super(ResetTimerEvent.type); }
}

export class RandomizeEvent extends CustomEvent<boolean> {
	static type = 'mist.common.randomize';
	constructor(randomize: boolean) { super(RandomizeEvent.type, { detail: randomize }); }
}

export class FilterLinkEvent extends CustomEvent<HTMLAnchorElement> {
	static type = 'mist.common.filterlink';
	constructor(filterLink: HTMLAnchorElement) { super(FilterLinkEvent.type, { detail: filterLink })}
}
